/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';

const G   = '#1D9E75';
const GD  = '#0F6E56';
const INK = '#0F1A16';

export default function HomePage({ onNavigate }) {
  const go = (p) => { if (onNavigate) onNavigate(p); };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth < 1024);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  /* ── SVG icons ── */
  const Chk = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <polyline points="1.5,5 4,7.5 8.5,2" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  const ChkColored = ({ col }) => (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
      <polyline points="1.5,4.5 3.5,6.5 7.5,2" stroke={col || G} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  const Arrow = ({ color = '#fff' }) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2.5 7h9M8 3.5l3.5 3.5L8 10.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const sans = { fontFamily: "'DM Sans','Segoe UI',system-ui,sans-serif" };

  return (
    <div style={{ background: '#fff', color: INK, ...sans }}>
      <link rel="preconnect" href="https://fonts.googleapis.com"/>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet"/>

      {/* ══ HERO ══════════════════════════════════════════════════════════ */}
      <section style={{ paddingTop: 60, background: '#fff', overflow: 'hidden' }}>
        <div style={{
          maxWidth: 1240,
          margin: '0 auto',
          padding: isMobile ? '32px 20px 0' : isTablet ? '40px 24px 0' : '56px 32px 0',
          display: 'grid',
          gridTemplateColumns: isTablet ? '1fr' : '480px 1fr',
          gap: isTablet ? 40 : 52,
          alignItems: 'flex-start',
        }}>

          {/* ── LEFT ── */}
          <div style={{ paddingTop: isTablet ? 0 : 16 }}>

            {/* Badge FR */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              background: '#E8F5F0', border: '1px solid #A7E3CD',
              borderRadius: 20, padding: '4px 12px',
              marginBottom: 22, fontSize: 11, fontWeight: 600,
              color: GD, letterSpacing: '0.3px',
            }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: G, display: 'inline-block' }}/>
              LA PLATEFORME FRANÇAISE DE LA LOCATION COURTE DURÉE&nbsp;
              <svg width="18" height="13" viewBox="0 0 18 13" style={{ borderRadius: 2, flexShrink: 0 }}>
                <rect width="6" height="13" fill="#002395"/>
                <rect x="6" width="6" height="13" fill="#EDEDED"/>
                <rect x="12" width="6" height="13" fill="#ED2939"/>
              </svg>
            </div>

            {/* H1 */}
            <h1 style={{
              fontSize: isMobile ? 36 : isTablet ? 46 : 58,
              fontWeight: 700,
              lineHeight: 1.05,
              letterSpacing: isMobile ? '-1.5px' : '-2px',
              marginBottom: 18,
              color: INK,
            }}>
              Gagnez plus.<br/>
              <span style={{ color: G }}>Gérez moins.</span>
            </h1>

            <p style={{ fontSize: 15, color: '#4B5563', lineHeight: 1.7, marginBottom: 24, maxWidth: 460 }}>
              Havenly centralise tout pour les hôtes et conciergeries : plus de réservations, moins de tâches, zéro stress.
            </p>

            {/* Checklist */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 30 }}>
              {[
                { b: '8% de commission à vie',      r: ' — contre 15,5% Airbnb et 17% Booking' },
                { b: 'IA 24/7',                     r: ' qui répond à vos voyageurs automatiquement' },
                { b: 'Caution voyageurs possible',  r: ' — protection sécurisée via Stripe' },
                { b: 'Zéro frais cachés',           r: ' pour vos voyageurs, prix tout compris' },
              ].map((c, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                  <div style={{
                    width: 20, height: 20, borderRadius: '50%', background: G,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0, marginTop: 2,
                  }}><Chk/></div>
                  <span style={{ fontSize: 14, color: '#374151', lineHeight: 1.55 }}>
                    <strong style={{ fontWeight: 700, color: INK }}>{c.b}</strong>{c.r}
                  </span>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => go('auth')}
                style={{
                  background: INK, color: '#fff', border: 'none',
                  borderRadius: 9, fontSize: 15, fontWeight: 700,
                  padding: '13px 26px', cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 8,
                  transition: 'opacity .15s',
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '.88'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
              >
                Commencer gratuitement <Arrow/>
              </button>
              <button
                onClick={() => go('search')}
                style={{
                  background: 'transparent', color: INK,
                  border: '1.5px solid #E5E7EB',
                  borderRadius: 9, fontSize: 14, fontWeight: 600,
                  padding: '12px 22px', cursor: 'pointer',
                  transition: 'border-color .15s',
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = G}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#E5E7EB'}
              >
                Voir les logements
              </button>
            </div>

            {/* Social proof mini */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 20 }}>
              <div style={{ display: 'flex' }}>
                {['#1D9E75','#534AB7','#C4784A','#378ADD'].map((col, i) => (
                  <div key={i} style={{
                    width: 26, height: 26, borderRadius: '50%',
                    background: col, border: '2px solid #fff',
                    marginLeft: i > 0 ? -8 : 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 9, fontWeight: 700, color: '#fff',
                  }}>
                    {['JM','TL','SC','AR'][i]}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 12, color: '#6B7280' }}>
                <span style={{ color: INK, fontWeight: 600 }}>ces hôtes</span> nous font déjà confiance
              </div>
            </div>
          </div>

          {/* ── RIGHT — Dashboard iframe démo ── */}
          {!isTablet && (
            <div style={{ position: 'relative' }}>


              {/* Label "Démo live" */}
              <div style={{
                position: 'absolute', top: -14, left: 12, zIndex: 10,
                display: 'inline-flex', alignItems: 'center', gap: 6,
                background: INK, color: '#fff',
                fontSize: 10.5, fontWeight: 700,
                padding: '5px 12px', borderRadius: 20,
                boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
                letterSpacing: '.2px',
              }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: G, display: 'inline-block', animation: 'pulse 2s infinite' }}/>
                Dashboard interactif — essayez !
              </div>

              {/* iFrame — scaled to always render desktop layout */}
              <div style={{
                position: 'relative', zIndex: 1,
                borderRadius: 16,
                overflow: 'hidden',
                boxShadow: '0 24px 80px rgba(0,0,0,0.16), 0 4px 16px rgba(0,0,0,0.06)',
                border: '1px solid #DDE3DC',
                height: 560,
              }}>
                <iframe
                  src="/dashboard-demo.html"
                  style={{
                    width: 1080,
                    height: 700,
                    border: 'none',
                    display: 'block',
                    transform: 'scale(0.74)',
                    transformOrigin: 'top left',
                    pointerEvents: 'auto',
                  }}
                  title="Dashboard Havenly démo interactive"
                  scrolling="no"
                />
              </div>
            </div>
          )}

          {/* Mobile / Tablet : mini dashboard statique */}
          {isTablet && (
            <div style={{
              borderRadius: 14, overflow: 'hidden',
              border: '1px solid #DDE3DC',
              boxShadow: '0 12px 40px rgba(0,0,0,0.1)',
              background: '#fff',
              fontFamily: "'DM Sans','Segoe UI',system-ui,sans-serif",
            }}>
              {/* Topbar mini */}
              <div style={{ background: '#fff', borderBottom: '1px solid #E5E7EB', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', border: '2px solid #1D9E75', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0F1A16" strokeWidth="2.2"><path d="M3 21V9l9-6 9 6v12"/><path d="M9 21V13h6v8"/></svg>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#3D4D3E' }}>conciergerie riviera</div>
                    <div style={{ fontSize: 8, color: '#1D9E75', fontWeight: 500 }}>Gestionnaire</div>
                  </div>
                </div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#0F1A16' }}>Bonjour Julie 👋</div>
                <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#1D9E75', color: '#fff', fontSize: 9, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>JM</div>
              </div>

              {/* KPIs */}
              <div style={{ padding: '12px 14px', background: '#F4F6F4' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 8, marginBottom: 10 }}>
                  {[
                    { label: 'Revenus ce mois', val: '12 580 €', delta: '+18%', color: '#1D9E75', bg: '#E8F5F0' },
                    { label: "Taux d'occupation", val: '78%', delta: '+6 pts', color: '#7F77DD', bg: '#EEEDFE' },
                    { label: 'Réservations', val: '24', delta: '+4', color: '#378ADD', bg: '#E6F1FB' },
                    { label: 'En attente', val: '3', delta: 'À traiter', color: '#E24B4A', bg: '#FCEBEB' },
                  ].map((k, i) => (
                    <div key={i} style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 9, padding: '10px 12px', borderTop: `3px solid ${k.color}` }}>
                      <div style={{ fontSize: 9, color: '#9CA3AF', marginBottom: 4 }}>{k.label}</div>
                      <div style={{ fontSize: 18, fontWeight: 700, color: i === 3 ? '#E24B4A' : '#0F1A16', letterSpacing: '-0.5px' }}>{k.val}</div>
                      <div style={{ fontSize: 9, fontWeight: 600, color: k.color, marginTop: 2 }}>{i < 3 ? '↑' : ''} {k.delta}</div>
                    </div>
                  ))}
                </div>

                {/* Biens */}
                <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 9, padding: '10px 12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontSize: 10, fontWeight: 600, color: '#0F1A16' }}>Mes biens</span>
                    <span style={{ fontSize: 9, color: '#1D9E75', fontWeight: 500 }}>Voir tous →</span>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 7 }}>
                    {[
                      { name: 'Villa Azur', city: 'Cannes', occ: 82, rev: '2 350 €', tag: 'Optimisé', tc: '#0F6E56', tb: '#E8F5F0', img: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=300&h=120&fit=crop&auto=format' },
                      { name: 'Appt Vieux-Port', city: 'Marseille', occ: 65, rev: '1 890 €', tag: 'À améliorer', tc: '#C4784A', tb: '#FDF0E6', img: 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=300&h=120&fit=crop&auto=format' },
                    ].map((b, i) => (
                      <div key={i} style={{ border: '1px solid #E5E7EB', borderRadius: 7, overflow: 'hidden' }}>
                        <div style={{ height: 60, position: 'relative', overflow: 'hidden' }}>
                          <img src={b.img} alt={b.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                          <span style={{ position: 'absolute', bottom: 3, left: 4, fontSize: 7, background: b.tb, color: b.tc, padding: '1px 5px', borderRadius: 3, fontWeight: 700 }}>{b.tag}</span>
                        </div>
                        <div style={{ padding: '6px 8px' }}>
                          <div style={{ fontSize: 9.5, fontWeight: 700, color: '#0F1A16' }}>{b.name}</div>
                          <div style={{ fontSize: 8, color: '#9CA3AF', marginBottom: 4 }}>{b.city}</div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div><div style={{ fontSize: 10, fontWeight: 700 }}>{b.rev}</div><div style={{ fontSize: 7, color: '#9CA3AF' }}>Ce mois</div></div>
                            <div style={{ textAlign: 'right' }}><div style={{ fontSize: 10, fontWeight: 700, color: b.occ >= 70 ? '#1D9E75' : '#C4784A' }}>{b.occ}%</div><div style={{ fontSize: 7, color: '#9CA3AF' }}>Occupation</div></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Badge démo + bouton */}
              <div style={{ background: '#0F1A16', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#1D9E75', display: 'inline-block', flexShrink: 0 }}/>
                  <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: 500, lineHeight: 1.4 }}>Dashboard complet sur desktop</span>
                </div>
                <a
                  href="/dashboard-demo.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 7,
                    background: '#1D9E75', color: '#fff',
                    fontSize: 13, fontWeight: 700,
                    padding: '10px 20px', borderRadius: 24,
                    textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0,
                    boxShadow: '0 0 0 0 rgba(29,158,117,0.5)',
                    animation: 'demoPulse 1.8s ease-in-out infinite',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                    <polygon points="5,3 19,12 5,21"/>
                  </svg>
                  Voir la démo
                </a>
              </div>
            </div>
          )}
        </div>

        {/* ── TRUST BAR ── */}
        <div style={{ borderTop: '1px solid #EAECEF', marginTop: 52, background: '#FAFBFA' }}>
          <div style={{ maxWidth: 1240, margin: '0 auto', padding: '0 32px' }}>
            <p style={{
              textAlign: 'center', fontSize: 11, color: '#9CA3AF',
              padding: '12px 0 0', fontWeight: 500, letterSpacing: '0.5px', textTransform: 'uppercase',
            }}>Ils nous font confiance</p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
              borderTop: '1px solid #EAECEF', marginTop: 10,
            }}>
              {[
                {
                  left: (
                    <>
                      <div style={{ display: 'flex', gap: 2 }}>
                        {'★★★★★'.split('').map((s, j) => <span key={j} style={{ color: '#C4784A', fontSize: 16 }}>{s}</span>)}
                      </div>
                      <div style={{ fontSize: 14, fontWeight: 700, marginTop: 3 }}>4,9/5</div>
                      <div style={{ fontSize: 12, color: '#6B7280' }}>sur +600 avis</div>
                    </>
                  ),
                },
                {
                  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.5"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>,
                  val: '0 abonnement', label: 'Toutes les fonctionnalités gratuites', ibg: '#E8F5F0',
                },
                { emoji: '🇫🇷', val: 'Made in France', label: 'Plateforme 100% française', ibg: '#EEF4FF' },
                {
                  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
                  val: 'Support 7j/7', label: 'Une équipe française à votre service', ibg: '#EEEDFE',
                },
              ].map((item, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '16px 20px',
                  borderRight: i < 3 && !isMobile ? '1px solid #EAECEF' : 'none',
                  borderBottom: isMobile && i < 2 ? '1px solid #EAECEF' : 'none',
                  justifyContent: isMobile ? 'center' : 'flex-start',
                  textAlign: isMobile ? 'center' : 'left',
                }}>
                  {i === 0 ? (
                    <div style={{ textAlign: isMobile ? 'center' : 'left' }}>{item.left}</div>
                  ) : (
                    <>
                      <div style={{
                        width: 38, height: 38, borderRadius: 10,
                        background: item.ibg,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, fontSize: 18,
                      }}>
                        {item.icon || <span>{item.emoji}</span>}
                      </div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: INK }}>{item.val}</div>
                        <div style={{ fontSize: 11.5, color: '#6B7280' }}>{item.label}</div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══ FEATURES ══════════════════════════════════════════════════════ */}
      <section style={{ padding: isMobile ? '48px 20px' : '72px 32px', background: '#fff' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isTablet ? '1fr' : '280px 1fr',
            gap: isTablet ? 28 : 52,
            alignItems: 'flex-start',
          }}>
            <div>
              <h2 style={{ fontSize: isMobile ? 22 : 28, fontWeight: 700, letterSpacing: '-0.8px', lineHeight: 1.25, color: INK, marginBottom: 14 }}>
                Tout ce dont vous avez besoin, réuni au même endroit.
              </h2>
              <div style={{ width: 36, height: 3, background: G, borderRadius: 2 }}/>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(2,1fr)',
              gap: 14,
            }}>
              {[
                {
                  icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
                  bg: '#EEEDFE', title: 'IA 24/7',
                  desc: 'Répond aux voyageurs, gère les demandes et vous fait gagner un temps fou.',
                },
                {
                  icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/></svg>,
                  bg: '#E8F5F0', title: 'Calendrier intelligent',
                  desc: 'Synchronisation multi-plateformes, prix optimisés et visibilité en temps réel.',
                },
                {
                  icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="1.5"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>,
                  bg: '#FDF0E6', title: 'Gestion simplifiée',
                  desc: 'Check-in, ménage, tâches, prestataires… tout organisé et suivi automatiquement.',
                },
                {
                  icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
                  bg: '#E8F5F0', title: 'Statistiques & revenus',
                  desc: 'Suivez vos performances et augmentez vos revenus grâce aux recommandations IA.',
                },
              ].map((f, i) => (
                <div
                  key={i}
                  style={{
                    padding: '18px', border: '1px solid #EAECEF',
                    borderRadius: 12, background: '#fff', transition: 'all .2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.07)'; e.currentTarget.style.borderColor = '#D1D9D4'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#EAECEF'; }}
                >
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: f.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>{f.icon}</div>
                  <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6, color: INK }}>{f.title}</div>
                  <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6 }}>{f.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══ HÔTES / CONCIERGERIES ══════════════════════════════════════════ */}
      <section style={{ padding: isMobile ? '48px 20px' : '0 32px 72px', background: '#F9FBF9' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', paddingTop: isMobile ? 0 : 64 }}>
          <h2 style={{ fontSize: isMobile ? 22 : 30, fontWeight: 700, letterSpacing: '-0.8px', textAlign: 'center', marginBottom: 36, color: INK }}>
            Une solution adaptée à chaque besoin
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 18 }}>
            {[
              {
                type: 'Hôtes', tagCol: G, tagBg: '#E8F5F0', isCircle: true,
                img: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&h=180&fit=crop&auto=format',
                imgAlt: 'Hôte Havenly',
                overlay: 'linear-gradient(135deg,rgba(232,245,240,0.55) 0%,rgba(29,158,117,0.25) 100%)',
                title: 'Vous gérez un ou plusieurs logements ?',
                desc: 'Havenly vous aide à développer vos revenus sans y passer plus de temps. Commission à 8% — la plus basse du marché.',
                items: ['Gestion simple et intuitive', 'Communication automatisée avec les voyageurs', 'Suivi des performances en temps réel'],
                btnBg: INK, chkCol: G, chkBg: '#E8F5F0',
                btnLabel: 'Découvrir pour les hôtes →',
              },
              {
                type: 'Conciergeries', tagCol: '#534AB7', tagBg: '#EEEDFE', isCircle: false,
                img: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=180&fit=crop&auto=format',
                imgAlt: 'Conciergerie Havenly',
                overlay: 'linear-gradient(135deg,rgba(238,237,254,0.55) 0%,rgba(127,119,221,0.3) 100%)',
                title: 'Vous gérez plusieurs biens pour vos clients ?',
                desc: 'Havenly centralise et automatise toute votre gestion opérationnelle. Dashboard multi-biens, prestataires, reporting.',
                items: ['Multi-biens et multi-clients', 'Coordination des prestataires', 'Reporting clair et professionnel'],
                btnBg: '#534AB7', chkCol: '#534AB7', chkBg: '#EEEDFE',
                btnLabel: 'Découvrir pour les conciergeries →',
              },
            ].map((card, ci) => (
              <div key={ci} style={{ borderRadius: 16, border: '1px solid #EAECEF', overflow: 'hidden', background: '#fff' }}>
                <div style={{ height: 160, position: 'relative', overflow: 'hidden' }}>
                  <img src={card.img} alt={card.imgAlt} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                  <div style={{ position: 'absolute', inset: 0, background: card.overlay }}/>
                </div>
                <div style={{ padding: '20px 24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, color: card.tagCol, marginBottom: 8 }}>
                    <div style={{ width: 7, height: 7, borderRadius: card.isCircle ? '50%' : 2, background: card.tagCol }}/>
                    {card.type}
                  </div>
                  <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, lineHeight: 1.3, color: INK }}>{card.title}</h3>
                  <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.7, marginBottom: 14 }}>{card.desc}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginBottom: 18 }}>
                    {card.items.map((item, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ width: 16, height: 16, borderRadius: '50%', background: card.chkBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <ChkColored col={card.chkCol}/>
                        </div>
                        <span style={{ fontSize: 13, color: '#374151' }}>{item}</span>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={() => go('auth')}
                    style={{ background: card.btnBg, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, padding: '10px 20px', cursor: 'pointer', transition: 'opacity .15s' }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '.88'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                  >
                    {card.btnLabel}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ VOYAGEURS ════════════════════════════════════════════════════ */}
      <section style={{ padding: isMobile ? '48px 20px' : '72px 32px', background: '#F0F5FF', borderTop: '1px solid #DDE8FF', borderBottom: '1px solid #DDE8FF' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', display: 'grid', gridTemplateColumns: isTablet ? '1fr' : '260px 1fr', gap: isTablet ? 32 : 48, alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: isMobile ? 22 : 26, fontWeight: 700, letterSpacing: '-0.5px', lineHeight: 1.3, marginBottom: 12, color: INK }}>
              Voyageurs, profitez de séjours uniques en toute confiance
            </h2>
            <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.7, marginBottom: 14 }}>
              Des logements sélectionnés avec soin, un service réactif et une réservation simple et sécurisée.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
              {['Aucun frais caché', 'Paiement 100% sécurisé', 'Support disponible 7j/7'].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#1A73E8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Chk/></div>
                  <span style={{ fontSize: 13, color: '#374151' }}>{item}</span>
                </div>
              ))}
            </div>
            <button
              onClick={() => go('search')}
              style={{ background: '#1A73E8', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, padding: '10px 20px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, transition: 'opacity .15s' }}
              onMouseEnter={e => e.currentTarget.style.opacity = '.88'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            >
              Découvrir nos logements
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5h9M7.5 3l3.5 3.5L7.5 10" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>
         </div>
      </section>

      {/* ══ TÉMOIGNAGES ═══════════════════════════════════════════════════ */}
      <section style={{ padding: isMobile ? '48px 20px' : '72px 32px', background: '#fff' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <h2 style={{ fontSize: isMobile ? 22 : 28, fontWeight: 700, letterSpacing: '-0.5px', textAlign: 'center', marginBottom: 36, color: INK }}>
            Ils ont augmenté leurs revenus avec Havenly
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap: 16 }}>
            {[
              { init: 'JD', name: 'Julien D.',  role: 'Propriétaire à Nice',         col: G,         bg: '#E8F5F0', text: "Depuis que j'utilise Havenly, j'ai augmenté mes revenus de 28% tout en passant beaucoup moins de temps sur la gestion. L'IA est un vrai game changer !" },
              { init: 'ML', name: 'Marie L.',   role: 'Conciergerie à Biarritz',     col: '#534AB7', bg: '#EEEDFE', text: "La gestion de mes 15 biens n'a jamais été aussi simple. Le calendrier, les prestataires, les messages… tout est centralisé au même endroit." },
              { init: 'TR', name: 'Thomas R.',  role: 'Propriétaire à Marseille',    col: '#C4784A', bg: '#FDF0E6', text: "Interface ultra intuitive, support au top et des frais vraiment raisonnables. Je recommande à 100% à tous les hôtes." },
            ].map((t, i) => (
              <div key={i} style={{ background: '#F9FAFB', border: '1px solid #EAECEF', borderRadius: 14, padding: '20px' }}>
                <div style={{ marginBottom: 10 }}>
                  {'★★★★★'.split('').map((s, j) => <span key={j} style={{ fontSize: 14, color: '#C4784A' }}>{s}</span>)}
                </div>
                <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.75, marginBottom: 16, fontStyle: 'italic' }}>"{t.text}"</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: t.bg, color: t.col, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{t.init}</div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: INK }}>{t.name}</div>
                    <div style={{ fontSize: 11, color: '#9CA3AF' }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ VALEURS ══════════════════════════════════════════════════════ */}
      <div style={{ borderTop: '1px solid #EAECEF', borderBottom: '1px solid #EAECEF', background: '#F9FBF9' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
          {[
            { label: 'SIMPLE',      desc: 'Une prise en main rapide, sans formation' },
            { label: 'SÉCURISÉ',   desc: 'Vos données et paiements sont protégés' },
            { label: 'TRANSPARENT', desc: 'Des tarifs clairs et justes, sans surprise' },
            { label: 'HUMAIN',      desc: 'Une équipe française disponible 7j/7' },
          ].map((v, i) => (
            <div key={i} style={{
              padding: '18px 20px',
              borderRight: !isMobile && i < 3 ? '1px solid #EAECEF' : 'none',
              borderBottom: isMobile && i < 2 ? '1px solid #EAECEF' : 'none',
            }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: G, letterSpacing: '1px', marginBottom: 4 }}>{v.label}</div>
              <div style={{ fontSize: 12.5, color: '#6B7280' }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ══ CTA FINAL ════════════════════════════════════════════════════ */}
      <section style={{ background: INK, padding: '0 32px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', right: -80, top: -60, width: 400, height: 400, borderRadius: '50%', background: 'rgba(29,158,117,0.06)', pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', left: -40, bottom: -40, width: 280, height: 280, borderRadius: '50%', background: 'rgba(29,158,117,0.04)', pointerEvents: 'none' }}/>
        <div style={{
          maxWidth: 1240, margin: '0 auto',
          display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr auto',
          gap: 32, alignItems: 'center',
          padding: isMobile ? '48px 0' : '64px 0',
          position: 'relative', zIndex: 1,
        }}>
          <div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              background: 'rgba(29,158,117,0.15)', border: '1px solid rgba(29,158,117,0.3)',
              borderRadius: 20, padding: '4px 12px', marginBottom: 16,
              fontSize: 11.5, fontWeight: 600, color: G,
            }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              Rejoignez Havenly dès aujourd'hui
            </div>
            <h2 style={{ fontSize: isMobile ? 24 : 30, fontWeight: 700, color: '#fff', lineHeight: 1.2, marginBottom: 10, letterSpacing: '-0.8px' }}>
              Prêt à développer vos revenus<br/>sereinement ?
            </h2>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)' }}>
              Rejoignez les hôtes et conciergeries qui font confiance à Havenly.
            </p>
          </div>
          <button
            onClick={() => go('auth')}
            style={{
              background: '#fff', color: INK, border: 'none',
              borderRadius: 10, fontSize: 15, fontWeight: 700,
              padding: '13px 28px', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 8,
              whiteSpace: 'nowrap', transition: 'opacity .15s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            Créer mon compte gratuitement
            <Arrow color={INK}/>
          </button>
        </div>
      </section>

      {/* ══ FOOTER ═══════════════════════════════════════════════════════ */}
      <footer style={{ background: '#0A130E', padding: '22px 32px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
            <svg viewBox="0 0 210 52" style={{ height: 20, width: 'auto', display: 'block' }} xmlns="http://www.w3.org/2000/svg">
  <text x="0" y="44" fontFamily="Georgia,'Times New Roman',serif" fontSize="52" fontWeight="400" fontStyle="italic" letterSpacing="-2" fill="#fff">haven<tspan fill="#1D9E75" dx="-3">ly</tspan></text>
</svg>
          </div>
          <div style={{ display: 'flex', gap: 18, fontSize: 12, color: 'rgba(255,255,255,0.3)', flexWrap: 'wrap' }}>
            {[
              { label: 'Mentions légales', action: () => go('legal') },
              { label: 'CGV',             action: () => onNavigate('legal', 'cgv') },
              { label: 'Confidentialité', action: () => onNavigate('legal', 'confidentialite') },
              { label: 'Contact',         action: () => { window.location.href = 'mailto:contact@havenly.fr'; } },
            ].map(({ label, action }) => (
              <span
                key={label}
                style={{ cursor: 'pointer', transition: 'color .15s' }}
                onClick={action}
                onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.65)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.3)'}
              >
                {label}
              </span>
            ))}
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)' }}>© 2025 Havenly · Made in France 🇫🇷</div>
        </div>
      </footer>

      {/* ══ GLOBAL STYLES ════════════════════════════════════════════════ */}
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        @keyframes demoPulse {
          0% { box-shadow: 0 0 0 0 rgba(29,158,117,0.6); transform: scale(1); }
          50% { box-shadow: 0 0 0 10px rgba(29,158,117,0); transform: scale(1.04); }
          100% { box-shadow: 0 0 0 0 rgba(29,158,117,0); transform: scale(1); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: .6; transform: scale(1.3); }
        }
        @media (max-width: 480px) {
          section { padding-left: 16px !important; padding-right: 16px !important; }
        }
      `}</style>
    </div>
  );
}
